import { render, staticRenderFns } from "./ModalMemberInfo.vue?vue&type=template&id=38a1f781&scoped=true&"
import script from "./ModalMemberInfo.vue?vue&type=script&lang=js&"
export * from "./ModalMemberInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalMemberInfo.vue?vue&type=style&index=0&id=38a1f781&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a1f781",
  null
  
)

export default component.exports